import { Box } from "@mui/material";
import React from "react";
import payment_section_bg from "../../assets/icons/payment_section_bg.svg";
import "./payment.section.css";
import { useTranslation } from "react-i18next";
export const PaymentSection = () => {
  const { t } = useTranslation();
  return (
    <Box className="payment-section">
      <img src={payment_section_bg} alt="background" />
      <Box className="payment-section__label">
        {t("main.payment_section.label")}
      </Box>
      <Box className="payment-section__container">
        <Box className="payment-section__cards">
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/master_section.svg`}
              alt="Master Card"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/visa_section.svg`}
              alt="Visa"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/sbp_section.svg`}
              alt="SBP"
            />
          </Box>
        </Box>
        <Box className="payment-section__crypto">
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/bnb_section.svg`}
              alt="BNB"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/litecoin_section.svg`}
              alt="Litecoin"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/dogecoin_section.svg`}
              alt="Dojecoin"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/ethereum_section.svg`}
              alt="Ethereum"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/bitcoin_section.svg`}
              alt="Bitcoin"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/notcoin_section.svg`}
              alt="Notcoin"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/toncoin_section.svg`}
              alt="Notcoin"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/usdt_section.svg`}
              alt="Notcoin"
            />
          </Box>
          <Box className="payment-section__item">
            <img
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/payments/tron_section.svg`}
              alt="Notcoin"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
